import React, { useState } from 'react';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Stack, Button } from '@mui/material';
import * as XLSX from 'xlsx';
import PopoverFiltroRelatorio from './PopoverFiltroRelatorio';
import generatePdfRelatorioIndicacoes from './EditPdfRelatorioIndicacoes';

export default function RelatorioIndicacoes({ data, type, filtro, setFiltro, onLimpar }) {
  const [openFiltro, setOpenFiltro] = useState(null);

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setOpenFiltro(false);
    onLimpar();
  };

  const onConfirmFiltro = (filtro) => {
    setOpenFiltro(false);
    setFiltro(filtro);
  };

  if (!data) return null;

  const exportarExcel = () => {
    const wb = XLSX.utils.book_new();
    const sheet = [];

    // Título + cabeçalho
    sheet.push(['1. Relação de Pagamentos']);
    sheet.push([
      'Indicador',
      'Cliente',
      'Valor Projeto (R$)',
      'Potência (kWp)',
      'Unidade',
      'Política Indicação',
      'Valor Pago',
      'Consultor',
      'Fabricante',
    ]);

    data.linhas.forEach((l) => {
      sheet.push([
        l.indicador,
        l.cliente,
        l.valor,
        l.potencia,
        l.unidade,
        l.politica,
        l.valorPago,
        l.consultor,
        l.fabricante,
      ]);
    });

    sheet.push([]);
    sheet.push(['2. Resumo']);
    sheet.push(['Métrica', 'Valor']); // Alterado para os cabeçalhos da nova tabela de resumo

    const r = data.resumo;
    sheet.push(['Total Pago', r.totalPago]);
    sheet.push(['Total Vendido', r.totalVendido]);
    sheet.push(['Participação no custo (%)', r.participacaoCusto]);
    sheet.push(['Potência vendida (kWp)', r.potenciaVendida]);
    sheet.push(['Política mais usada', r.politicaMaisUsada]);
    sheet.push(['Maior indicador', r.maiorIndicador]);
    sheet.push(['Consultor com mais indicações', r.consultorComMaisIndicacoes]);
    sheet.push(['Fabricante mais utilizado', r.fabricanteMaisUtilizado]);
    sheet.push(['Ticket Médio (R$)', r.ticketMedioReais]);
    sheet.push(['Ticket Médio (kWp)', r.ticketMedioKwp]);
    sheet.push(['Ticket Médio Indicações (R$)', r.ticketMedioIndicacao]);
    sheet.push(['Taxa de Conversão (%)', r.taxaConversao]);

    const ws = XLSX.utils.aoa_to_sheet(sheet);
    XLSX.utils.book_append_sheet(wb, ws, 'Indicações');
    XLSX.writeFile(wb, 'relatorio-indicacoes.xlsx');
  };

  return (
    <Box mt={4}>
      <Stack direction="row" justifyContent="flex-end" gap={2} sx={{ mb: 2 }}>
        <Button variant="outlined" onClick={(e) => setOpenFiltro(true)}>
          Filtro
        </Button>
        <Button variant="outlined" color="secondary" onClick={() => generatePdfRelatorioIndicacoes(data, filtro)}>
          Exportar em PDF
        </Button>
        <Button variant="contained" onClick={exportarExcel}>
          Download Excel
        </Button>
      </Stack>
      <Typography variant="h6">1. Relação de Pagamentos</Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Indicador</TableCell>
            <TableCell>Cliente</TableCell>
            <TableCell>Valor Projeto (R$)</TableCell>
            <TableCell>Potência (kWp)</TableCell>
            <TableCell>Unidade</TableCell>
            <TableCell>Política Indicação</TableCell>
            <TableCell>Valor Pago</TableCell>
            <TableCell>Consultor</TableCell>
            <TableCell>Fabricante</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.linhas.map((l, i) => (
            <TableRow key={i}>
              <TableCell>{l.indicador}</TableCell>
              <TableCell>{l.cliente}</TableCell>
              <TableCell>{l.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
              <TableCell>{l.potencia?.toFixed(2)}</TableCell>
              <TableCell>{l.unidade}</TableCell>
              <TableCell>{l.politica}</TableCell>
              <TableCell>{l.valorPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
              <TableCell>{l.consultor}</TableCell>
              <TableCell>{l.fabricante}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box mt={4}>
        <Typography variant="h6">2. Resumo</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Métrica</TableCell>
              <TableCell>Valor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Total pago</TableCell>
              <TableCell>
                {data.resumo.totalPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Total vendido</TableCell>
              <TableCell>
                {data.resumo.totalVendido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Participação no custo</TableCell>
              <TableCell>{data.resumo.participacaoCusto.toFixed(2)}%</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Potência vendida</TableCell>
              <TableCell>{data.resumo.potenciaVendida.toFixed(2)} kWp</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Política mais usada</TableCell>
              <TableCell>{data.resumo.politicaMaisUsada}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Maior indicador</TableCell>
              <TableCell>{data.resumo.maiorIndicador}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Consultor com mais indicações</TableCell>
              <TableCell>{data.resumo.consultorComMaisIndicacoes}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Fabricante mais utilizado</TableCell>
              <TableCell>{data.resumo.fabricanteMaisUtilizado}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Ticket Médio (R$)</TableCell>
              <TableCell>
                {data.resumo.ticketMedioReais.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Ticket Médio (kWp)</TableCell>
              <TableCell>{data.resumo.ticketMedioKwp.toFixed(2)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Ticket Médio Indicações (R$)</TableCell>
              <TableCell>
                {data.resumo.ticketMedioIndicacao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Taxa de Conversão</TableCell>
              <TableCell>{data.resumo.taxaConversao.toFixed(2)}%</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
      {openFiltro && (
        <PopoverFiltroRelatorio
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
          type={type}
        />
      )}
    </Box>
  );
}